import { render, staticRenderFns } from "./FormattedGlossName.vue?vue&type=template&id=0d39724e&"
import script from "./FormattedGlossName.vue?vue&type=script&lang=ts&"
export * from "./FormattedGlossName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports